import {JsonAdapter} from "../helpers/JsonAdapter";
import {User} from "./User";
import {Organisation} from "./Organisation";
import {UserProfile} from "./UserProfile";
import {IndividualProfile} from "./IndividualProfile";
import {Vacancy} from "./Vacancy";
import {EnvironmentService} from "../services/environment.service";

export class InterestAlert {

  RESPONSE_OPTIONS: {[key: string]: string} = {
    apply_online: "Apply Online",
    sendcv: "Send CV",
    contact: "Direct Contact"
  }

  id: string = "";
  organisation: Organisation | null = null;
  organisation_user_profile: UserProfile | null = null;
  candidate_organisation: Organisation | null = null;
  candidate_profile: UserProfile | null = null;
  response_option: string = "";
  created_at: string = "";
  status: string = "";
  message: string = "";
  message_response: string = "";
  url: string = "";
  vacancy: Vacancy | null = null;
  outcome: string = "";
  attachment: any[] = [];
  decline_reason: string = "";
  decline_reason_detail: string = "";
  organisation_user_name: string = "";

  number_of_unread_messages_for_candidate: number = 0;
  number_of_unread_messages_for_organisation: number = 0;

  has_new_action_for_candidate: boolean = false;
  has_new_action_for_organisation: boolean = false;

  latest_action_for_candidate: string = "";
  latest_action_for_organisation: string = "";

  archived: boolean = false;

  static create(object:any, env: EnvironmentService | null = null): InterestAlert {
    const item = JsonAdapter.fill(new InterestAlert(), object);

    if(object.organisation_user_profile) {
      item.organisation_user_profile = UserProfile.create(object.organisation_user_profile);
    }

    if(object.candidate_profile) {
      item.candidate_profile = IndividualProfile.create(object.candidate_profile);
    }

    if(object.organisation) {
      item.organisation = Organisation.create(object.organisation, env);
    }

    if(object.candidate_organisation) {
      item.candidate_organisation = Organisation.create(object.candidate_organisation);
    }

    if(object.vacancy) {
      item.vacancy = Vacancy.create(object.vacancy);
    }

    item.attachment = object.attachment;

    return item;
  }

  get responseOption(): string {
    return this.RESPONSE_OPTIONS[this.response_option];
  }

  static createMultiple(objects: InterestAlert[], env: EnvironmentService | null = null): InterestAlert[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(InterestAlert.create(objects[i], env));
    }
    return items;
  }

  get candidate_profile_as_individual(): IndividualProfile | null {
    return this.candidate_profile as IndividualProfile | null;
  }

  get declineReasonDisplay(): string {
    if(this.status === "declined") {
      if(this.decline_reason === 'not_interested_job') {
        return "Candidate is not interested in the suggested job.";
      } else if(this.decline_reason === 'not_interested_company') {
        return "Candidate is not interested in the company.";
      } else if(this.decline_reason === 'other' && this.decline_reason_detail) {
        return "Not interested - Reason: " + this.decline_reason_detail;
      }

      return "Not interested";
    }

    return "";
  }

  get displayedOutcome() {
    switch (this.outcome) {
      case 'declined':
        return 'Candidate Declined Contact';
      case 'recruited':
        return 'Hired';
      case 'interviewed_but_not_hired':
        return 'Interviewed but not hired';
      case 'not_selected_for_interview':
        return 'Not selected for interview';
      case 'application_not_completed':
        return 'Application not completed';
    }

    return "Select Outcome";
  }
}
